import {testIds} from '@dms/routes';
import {Main} from '@dms/shared';

import type {EagGridMaximization} from 'features/eag-grid';

import {VehicleInterestsCard} from './components/VehicleInterestsCard';

interface InterestsProps {
  maximization?: EagGridMaximization;
}

export function Interests(props: InterestsProps) {
  return (
    <Main data-testid={testIds.vehicles.interests('page')}>
      <VehicleInterestsCard maximization={props.maximization} />
    </Main>
  );
}
